import { create } from 'zustand'
import { persist } from 'zustand/middleware'

interface UiState {
  isDark: boolean
  fabVisible: boolean
  fabDate: string | null
  upcomingDays: number
  subPageTitle: string | null
  toggleDark: () => void
  toggleFabVisible: () => void
  setUpcomingDays: (days: number) => void
  triggerFab: (date: string) => void
  clearFabDate: () => void
  setSubPageTitle: (title: string | null) => void
}

export const useUiStore = create<UiState>()(
  persist(
    (set) => ({
      isDark: false,
      fabVisible: true,
      fabDate: null,
      upcomingDays: 14,
      subPageTitle: null,

      toggleDark: () => {
        set(s => {
          const next = !s.isDark
          document.documentElement.classList.toggle('dark', next)
          return { isDark: next }
        })
      },

      toggleFabVisible: () => set(s => ({ fabVisible: !s.fabVisible })),
      setUpcomingDays: (days) => set({ upcomingDays: days }),
      triggerFab: (date) => set({ fabDate: date }),
      clearFabDate: () => set({ fabDate: null }),
      setSubPageTitle: (title) => set({ subPageTitle: title }),
    }),
    {
      name: 'cal_ui',
      partialize: (state) => ({ isDark: state.isDark, fabVisible: state.fabVisible, upcomingDays: state.upcomingDays }),
      onRehydrateStorage: () => (state) => {
        if (state?.isDark) document.documentElement.classList.add('dark')
      },
    }
  )
)
